import formatDate from "./formatDate";

function hasExpired(finishDate) {
  const format = "YYYYMMDDHHmm";
  const now = new Date();
  return finishDate
    ? formatDate(now, format) > formatDate(finishDate, format)
    : false;
}

export default hasExpired;
